import '../css/tudor-theme.less';
import '../css/tudor-theme-nav.less';

const initializeTudorTheme = () => {
  const header = document.querySelector('[data-tudor-theme-nav]');
  if (!header) return;
  const menu = header.querySelector('[data-tudor-menu]');
  const toggle = menu.querySelector('summary');
  const desktop = window.matchMedia('(min-width: 1100px)');
  const setMenuForViewport = () => {
    menu.open = desktop.matches;
    toggle.setAttribute('aria-expanded', String(menu.open));
  };
  setMenuForViewport();
  desktop.addEventListener('change', setMenuForViewport);
  menu.addEventListener('toggle', () => toggle.setAttribute('aria-expanded', String(menu.open)));
  header.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !desktop.matches && menu.open) {
      menu.open = false;
      toggle.focus();
    }
  });
  const normalize = (path) => path.replace(/^\/fr(?=\/|$)/, '').replace(/\/$/, '') || '/';
  const path = normalize(window.location.pathname);
  const links = [...header.querySelectorAll('.rf-tudor-nav__links a')];
  const current = links.find((link) => normalize(new URL(link.href).pathname) === path);
  if (current) current.setAttribute('aria-current', 'page');
  else if (['/tudor-black-bay', '/tudor-pelagos', '/tudor-royal', '/tudor-ranger', '/tudor-1926'].includes(path)) {
    links.find((link) => normalize(new URL(link.href).pathname) === '/tudor-collection')?.setAttribute('aria-current', 'location');
  }
  if (path === '/collections/timepieces/tudor' || path.startsWith('/collections/timepieces/tudor/')) {
    header.querySelector('.rf-tudor-nav__shop').setAttribute('aria-current', 'location');
  }
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeTudorTheme, { once: true });
else initializeTudorTheme();
